export const TIMER_STATUS = {
  ACTIVE: 1,
  PAUSE: 2,
  COMPLETED: 3,
  SAVED: 4
}



// WEBPACK FOOTER //
// ./src/constants/timerStatus.js